<i class="shrink-0 text-[1.25em]" [ngClass]="iconClass()"></i>
<span class="truncate">{{ labelKey() | transloco }}</span>
@if (withTooltip()) {
  <app-directus-tooltip [tooltip]="tooltipKey() | transloco" />
}
